export default __webpack_public_path__ + "static/island-life-banner-mobile-c586dec0680afdc560acef8bda69d341.webp";